import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { AbstractJastVisitor } from '@atlassianlabs/jql-ast';
import { JQLEditorSchema } from '../../../schema';
import getDocumentPosition from '../../common/get-document-position';
import { getJastFromState } from '../../jql-ast';
import { RICH_INLINE_NODE } from '../constants';
export var replaceRichInlineNodes = function replaceRichInlineNodes(editorState, hydratedValues) {
  var ast = getJastFromState(editorState);
  var transaction = editorState.tr;
  // Do not allow users to revert this transaction with undo command so they can't land in an unhydrated state
  transaction.setMeta('addToHistory', false);
  Object.entries(hydratedValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      fieldName = _ref2[0],
      values = _ref2[1];
    values.forEach(function (value) {
      if (value.type === 'user') {
        var astNodes = getValueNodes(ast, fieldName, value.id);
        astNodes.forEach(function (astNode) {
          if (astNode.position) {
            var _astNode$position = _slicedToArray(astNode.position, 2),
              from = _astNode$position[0],
              to = _astNode$position[1];
            var documentFrom = getDocumentPosition(transaction.doc, from);
            if (!isRichInlineNode(transaction.doc, documentFrom)) {
              var documentTo = getDocumentPosition(transaction.doc, to);
              var node = getRichInlineNode(fieldName, value, astNode.text);
              transaction.replaceWith(documentFrom, documentTo, node);
            }
          }
        });
      }
    });
  });
  return transaction;
};
var getRichInlineNode = function getRichInlineNode(fieldName, value, text) {
  switch (value.type) {
    case 'user':
      {
        var textContent = JQLEditorSchema.text(text);
        return JQLEditorSchema.nodes.user.create(_objectSpread(_objectSpread({}, value), {}, {
          fieldName: fieldName
        }), textContent);
      }
    default:
      {
        throw new Error("Unsupported hydrated value type ".concat(value.type));
      }
  }
};
var isRichInlineNode = function isRichInlineNode(doc, position) {
  var _doc$resolve$nodeAfte;
  return ((_doc$resolve$nodeAfte = doc.resolve(position).nodeAfter) === null || _doc$resolve$nodeAfte === void 0 ? void 0 : _doc$resolve$nodeAfte.type.spec.group) === RICH_INLINE_NODE;
};
var getValueNodes = function getValueNodes(ast, field, value) {
  if (!ast.query) {
    return [];
  }
  return ast.query.accept(new FindValuesVisitor(field, value));
};
var FindValuesVisitor = /*#__PURE__*/function (_AbstractJastVisitor) {
  _inherits(FindValuesVisitor, _AbstractJastVisitor);
  var _super = _createSuper(FindValuesVisitor);
  function FindValuesVisitor(field, value) {
    var _this;
    _classCallCheck(this, FindValuesVisitor);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "visitQuery", function (query) {
      if (query.where === undefined) {
        return [];
      }
      return query.where.accept(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "visitCompoundClause", function (compoundClause) {
      return compoundClause.clauses.reduce(function (operands, compoundClause) {
        return [].concat(_toConsumableArray(operands), _toConsumableArray(compoundClause.accept(_assertThisInitialized(_this))));
      }, []);
    });
    _defineProperty(_assertThisInitialized(_this), "visitTerminalClause", function (terminalClause) {
      if (terminalClause.field.value !== _this.field) {
        return [];
      }
      if (terminalClause.operand === undefined) {
        return [];
      }
      return terminalClause.operand.accept(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "visitNotClause", function (notClause) {
      return notClause.clause.accept(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "visitValueOperand", function (valueOperand) {
      if (valueOperand.value !== _this.value) {
        return [];
      }
      return [valueOperand];
    });
    _defineProperty(_assertThisInitialized(_this), "visitListOperand", function (listOperand) {
      return listOperand.values.reduce(function (values, operand) {
        return [].concat(_toConsumableArray(values), _toConsumableArray(operand.accept(_assertThisInitialized(_this))));
      }, []);
    });
    _this.field = field;
    _this.value = value;
    return _this;
  }
  _createClass(FindValuesVisitor, [{
    key: "aggregateResult",
    value: function aggregateResult(aggregate, nextResult) {
      return [].concat(_toConsumableArray(aggregate), _toConsumableArray(nextResult));
    }
  }, {
    key: "defaultResult",
    value: function defaultResult() {
      return [];
    }
  }]);
  return FindValuesVisitor;
}(AbstractJastVisitor);